import { render, staticRenderFns } from "./StatusWidget.vue?vue&type=template&id=1f34f8d5&scoped=true"
import script from "./StatusWidget.vue?vue&type=script&lang=js"
export * from "./StatusWidget.vue?vue&type=script&lang=js"
import style0 from "./StatusWidget.vue?vue&type=style&index=0&id=1f34f8d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34f8d5",
  null
  
)

export default component.exports